import { breadcrumbLinkStyles } from "@packages/ds";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const BreadcrumbLink = styled(Link)`
  ${breadcrumbLinkStyles}
`;
